import { FC } from 'react';

import { ProductPickerFlow } from '../product-detail-flow/product-picker-flow';

import { IProductCustomizationPickerAspectProps } from './types';

export const ProductCustomizationPickerAspects: FC<IProductCustomizationPickerAspectProps> = ({
  pickerData,
  pickerSlotNumberToCustomize,
  userSelectedPickerAspects,
  filteredPickerAspects,
  getPreviousPickerSelectionIdentifiers,
  selectedPickerAspects,
  setSelectedPickerAspects,
}: IProductCustomizationPickerAspectProps) => {
  return (
    <ProductPickerFlow
      pickerSlotNumberToCustomize={pickerSlotNumberToCustomize}
      pickerData={pickerData}
      userSelectedPickerAspects={userSelectedPickerAspects}
      filteredPickerAspects={filteredPickerAspects}
      getPreviousPickerSelectionIdentifiers={getPreviousPickerSelectionIdentifiers}
      selectedPickerAspects={selectedPickerAspects}
      setSelectedPickerAspects={setSelectedPickerAspects}
    />
  );
};
